<script setup lang="ts"></script>

<template>
  <v-app>
    <v-main class="bg-background">
      <slot />
    </v-main>
  </v-app>
</template>
